import React, { useEffect } from 'react';
import { X, Check, AlertTriangle, Info, AlertCircle } from 'lucide-react';

const Toast = ({ toast, onClose }) => {
  useEffect(() => {
    if (toast.autoHideDuration && toast.autoHideDuration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, toast.autoHideDuration);

      return () => clearTimeout(timer);
    }
  }, [toast.autoHideDuration, onClose]);

  const getIconAndColor = () => {
    switch (toast.type) {
      case 'success':
        return {
          bgColor: 'bg-green-50 border-green-200',
          textColor: 'text-green-600',
          icon: <Check size={20} />
        };
      case 'error':
        return {
          bgColor: 'bg-red-50 border-red-200',
          textColor: 'text-red-600',
          icon: <AlertCircle size={20} />
        };
      case 'warning':
        return {
          bgColor: 'bg-yellow-50 border-yellow-200',
          textColor: 'text-yellow-600',
          icon: <AlertTriangle size={20} />
        };
      case 'info':
      default:
        return {
          bgColor: 'bg-blue-50 border-blue-200',
          textColor: 'text-blue-600',
          icon: <Info size={20} />
        };
    }
  };

  const { bgColor, textColor, icon } = getIconAndColor();

  return (
    <div className={`${bgColor} border rounded-lg shadow-lg p-4 max-w-sm w-full mb-3 transform transition-all duration-300 ease-in-out animate-slide-in`}>
      <div className="flex items-start justify-between">
        <div className="flex items-start flex-1 min-w-0">
          <div className={`flex-shrink-0 ${textColor} mr-3 mt-0.5`}>
            {icon}
          </div>
          <div className="flex-1 min-w-0">
            {toast.title && (
              <h4 className="text-sm font-medium text-gray-900 mb-1">
                {toast.title}
              </h4>
            )}
            <p className="text-sm text-gray-700">
              {toast.message}
            </p>
          </div>
        </div>
        <button
          onClick={onClose}
          className="flex-shrink-0 ml-3 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Close"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default Toast;
